import { Component, Input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

@Component({
  selector: 'wl-skeleton-loading-card',
  templateUrl: './skeleton-loading-card.component.html',
  styleUrls: [
    './skeleton-loading-card.component.ed.scss',
    './skeleton-loading-card.component.essent.scss',
  ],
  standalone: true,
  imports: [NgTemplateOutlet, AutomationIdDirective],
})
export class SkeletonLoadingCardComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public amountOfLines = 4;

  get arrayOfLines() {
    return Array(this.amountOfLines);
  }
}
